module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"best_for":"Ideal für:"},"en":{"best_for":"Best for:"},"es":{"best_for":"Lo mejor para:"},"fr":{"best_for":"Idéal pour :"},"it":{"best_for":"Indicato per:"},"ja":{"best_for":"適している用途:"},"pt":{"best_for":"Melhor para:"}}')
  delete Component.options._Ctor
}
